import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { lookupElement } from '../../methods/lookupElement'
import withPosition from '../withPosition/withPosition'
import React from 'react'
import { closePreview, openModal, forceMediaPause } from '../../actions/common'
import { hotspotMediaViewed } from '../../actions/hotspotActions'
import Preview from '../../components/2d/preview/Preview'
import { PanoramaSizes } from 'aria-viewer/players'
import { delay } from '../../../utils/functions'
import { playAudio, AUDIO_HS } from 'aria-viewer/audiomanager/audioManagerActions'

const getMediaURL = (mediaItem, type) => {
    switch (type) {
        case 'photo':
            return mediaItem.external_url
        case 'panorama':
            return {
                largeSourceURL: getPanoramaURL(mediaItem),
                smallSourceURL: getPanoramaURL(mediaItem, PanoramaSizes.SIZE_512),
            }
        case 'video':
            return mediaItem.largeurl
        default:
            return null
    }
}

const getPanoramaURL = (mediaItem, size = PanoramaSizes.SIZE_2048) => `${mediaItem.external_url}${size}.jpg`

const mapStateToProps = state => {
    const { type, id, previewType } = state.getIn(['interactiveElements', 'preview']).toJS()
    if (id) {
        const el = lookupElement({ type, id, state, toJS: true })
        const mediaItem = lookupElement({ type: 'mediaItems', id: el.mediaItems[0], state, toJS: true })
        const mediaUrl = getMediaURL(mediaItem, previewType)
        return {
            ...el,
            type,
            previewType,
            mediaUrl,
        }
    } else {
        return {}
    }
}

const mapDispatchToProps = dispatch => ({
    closePreview: () => {
        dispatch(closePreview())
    },
    openModal: el => {
        dispatch(openModal(el))
    },
    registerAudio: () => {
        dispatch(playAudio(AUDIO_HS))
    },
    setForcePause: pause => {
        dispatch(forceMediaPause(pause))
    },
    hotspotMediaViewed: hotspotType => {
        dispatch(hotspotMediaViewed({ hotspotType }))
    },
})

const mergeProps = (state, actions, ownProps) => ({
    ...state,
    ...actions,
    ...ownProps,
    onMouseLeave: () => {
        const { closePreview } = actions
        closePreview()
    },
    onClick: e => {
        const { openModal, registerAudio, setForcePause, hotspotMediaViewed } = actions
        const { id, previewType, mediaItems, type } = state

        hotspotMediaViewed(previewType)
        if (previewType === 'video') registerAudio()
        setForcePause(true)

        openModal({
            id,
            mediaType: previewType,
            mediaId: mediaItems[0],
            type,
        })
    },
})

const noIdNoRender = Component =>
    class extends React.PureComponent {
        constructor(props) {
            super(props)
            this.state = {
                mounted: !!props.id,
                visible: !!props.id,
            }
        }
        componentWillReceiveProps(newProps) {
            if (newProps.id && !this.props.id) {
                this.setState({ mounted: true, visible: true })
            } else if (!newProps.id && this.props.id) {
                this.setState({ mounted: false })
            }
        }

        handleUnmount = (cb, time = 300) => {
            this.setState({ visible: false }, () => {
                delay(time).then(() => cb())
            })
        }

        render() {
            const {
                props,
                state: { mounted, visible },
            } = this
            return mounted && <Component onUnmount={this.handleUnmount} isVisible={!!visible} {...props} />
        }
    }
export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
        mergeProps
    ),
    noIdNoRender,
    withPosition
)(Preview)
